export interface Domain {
	name: string;
	children: Array<Domain>;
}

export const globalDomainId = 'DM-0000000001';